import React from "react";
import { motion } from "framer-motion";
import { Card } from "../types/game";
import { CardSVG } from "../cards";

export type FlyingCardData = {
  card: Card;
  from: DOMRect;
  to: DOMRect;
  faceDown?: boolean;
  rotation?: number; // Optional rotation in degrees
  duration?: number; // Optional animation duration in seconds
};

interface FlyingCardProps {
  flyingCard: FlyingCardData;
  onAnimationComplete: () => void;
}

export const FlyingCard: React.FC<FlyingCardProps> = ({ flyingCard, onAnimationComplete }) => {
  const { card, from, to, faceDown = false, rotation: customRotation, duration = 0.25 } = flyingCard;

  // Calculate center positions for smoother animation
  const fromX = from.left + from.width / 2;
  const fromY = from.top + from.height / 2;
  const toX = to.left + to.width / 2;
  const toY = to.top + to.height / 2;

  // Calculate card dimensions (matching the scale used in hand: 0.24)
  const cardWidth = from.width;
  const cardHeight = from.height;

  return (
    <motion.div
      initial={{
        x: fromX - cardWidth / 2,
        y: fromY - cardHeight / 2,
        rotate: 0,
        scale: 1,
        opacity: 1,
      }}
      animate={{
        x: toX - cardWidth / 2,
        y: toY - cardHeight / 2,
        rotate: customRotation !== undefined ? customRotation : 12,
        scale: 0.9,
        opacity: 0.95,
      }}
      exit={{
        opacity: 0,
        scale: 0.8,
      }}
      transition={{
        duration,
        ease: "easeInOut",
      }}
      onAnimationComplete={onAnimationComplete}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: cardWidth,
        height: cardHeight,
        zIndex: 10000,
        pointerEvents: "none",
        filter: "drop-shadow(0 10px 30px rgba(0,0,0,0.5))",
      }}
    >
      <CardSVG card={card} scale={0.24} faceDown={faceDown} />
    </motion.div>
  );
};
